onComplete(function () {
  var pageScroll = 100;
  window.addEventListener('scroll', () => {
    var scroll = getCurrentScroll();
    if (scroll >= pageScroll) {
      document.querySelector('.nav-header').classList.add('scroll');
    } else {
      document.querySelector('.nav-header').classList.remove('scroll');
    }
  });
  function getCurrentScroll() {
    return window.pageYOffset || document.documentElement.scrollTop;
  }

  // Mobile Menu
  const hamburger = document.querySelector('.hamburger');
  hamburger.addEventListener('click', event => {
    event.preventDefault();
    hamburger.querySelector('.hambergerIcon').classList.toggle('navbar--open');
    document.querySelector('.navbar-mobile').classList.toggle('navbar--open');
    navHeader.classList.toggle('navbar--open');
    document.body.classList.toggle('fixed');
  });
  if (document.querySelector('.header-img')) {
    document.querySelector('.nav-header').classList.add('white');
  }
});